import React from 'react'
import styled from '@emotion/styled'
import { Box, Display, FlexDirection, Heading4, Icon, Text } from '@gousto-internal/citrus-react'

type InfoPanelType = 'success' | 'error'

const InfoPanelHeader = styled(Heading4)`
  line-height: 20px;
`

const InfoPanel = styled(Box)<{ type: InfoPanelType }>`
  border: ${({ type }) => (type === 'error' ? '1px solid #f09ba0' : '1px solid #9cdc9e')};
  border-radius: 3px;
  background: ${({ type }) => (type === 'error' ? '#ffebef' : '#e6f7e7')};
`

const InfoPanelText = styled(Text)<{ type: InfoPanelType }>`
  color: ${({ type }) => (type === 'error' ? '#516272' : '#333d47')};
  font-weight: 375;
  line-height: 24px;
`

interface Props {
  title: string
  message: string
  type: InfoPanelType
}

export const PromoCodeInfoPanel: React.FC<Props> = ({ title, message, type }) => (
  <InfoPanel
    paddingH={4}
    paddingV={4}
    display={Display.Flex}
    gap={2}
    flexDirection={FlexDirection.Row}
    type={type}
  >
    <Box display={Display.Flex}>
      <Icon
        name={type === 'error' ? 'error' : 'success'}
        style={{ color: type === 'error' ? '#bc1256' : '#006700' }}
      />
    </Box>
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={1}>
      <InfoPanelHeader size={3}>{title}</InfoPanelHeader>
      <InfoPanelText size={4} type={type}>
        {message}
      </InfoPanelText>
    </Box>
  </InfoPanel>
)
